// Breadcrumb Scroll Gradient Controller
// Shows/hides fade gradient based on scroll position

class BreadcrumbScroll {
  constructor() {
    this.wrappers = document.querySelectorAll('.breadcrumbs-wrapper');
    if (this.wrappers.length === 0) return;

    this.init();
  }

  init() {
    this.wrappers.forEach((wrapper) => {
      const breadcrumbs = wrapper.querySelector('.breadcrumbs');
      const gradient = wrapper.querySelector('.breadcrumbs-gradient');

      if (!breadcrumbs || !gradient) return;

      // Check if we need gradient on load
      this.updateGradient(breadcrumbs, gradient);

      // Update on scroll
      breadcrumbs.addEventListener('scroll', () => {
        this.updateGradient(breadcrumbs, gradient);
      });

      // Update on window resize
      window.addEventListener('resize', () => {
        this.updateGradient(breadcrumbs, gradient);
      });
    });
  }

  updateGradient(breadcrumbs, gradient) {
    // Only apply on mobile
    if (window.innerWidth > 767) {
      gradient.classList.remove('is-active');
      return;
    }

    const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
    const scrollLeft = breadcrumbs.scrollLeft;
    const scrollWidth = breadcrumbs.scrollWidth;
    const clientWidth = breadcrumbs.clientWidth;

    // Check if content is scrollable
    const isScrollable = scrollWidth > clientWidth;

    if (!isScrollable) {
      gradient.classList.remove('is-active');
      return;
    }

    // For RTL, check if scrolled all the way to the left (negative values)
    // For LTR, check if scrolled all the way to the right
    let isAtEnd;
    if (isRTL) {
      // RTL scroll can be negative or positive depending on browser
      isAtEnd = Math.abs(scrollLeft) < 5;
    } else {
      // LTR - at end when scrollLeft + clientWidth >= scrollWidth
      isAtEnd = scrollLeft + clientWidth >= scrollWidth - 5;
    }

    // Show gradient if scrollable and not at the end
    if (isScrollable && !isAtEnd) {
      gradient.classList.add('is-active');
    } else {
      gradient.classList.remove('is-active');
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BreadcrumbScroll();
  });
} else {
  new BreadcrumbScroll();
}
